import { EmptyGuid } from '../emptyGuid';
import { luscinia } from '../luscinia';

export function openNewEventModal(eventRecordUrl: string, infoStartStr: string, infoEndStr: string, resourceId: string, filterColumnName: string) {
    if (resourceId != undefined && resourceId != EmptyGuid.value)
    {
        openCustomModal(`${eventRecordUrl}/modaledit?action=new&filtercolumnname=${filterColumnName}&parentid=${resourceId}&layerid=${luscinia.getModalLayerCount()}`).then((modalElement) => {
            luscinia.setValue(modalElement, 'Start', infoStartStr);
            luscinia.setValue(modalElement, 'End', infoEndStr);
            luscinia.setValue(modalElement, 'StartTime', extractTime(infoStartStr));
            luscinia.setValue(modalElement, 'EndTime', extractTime(infoEndStr));
        });
    }
}
function extractTime(dateTimeStr: string): string {
    const date = new Date(dateTimeStr);
    const hours = date.getHours().toString().padStart(2, '0');  // Ensure 2 digits for hours
    const minutes = date.getMinutes().toString().padStart(2, '0'); // Ensure 2 digits for minutes
    return `${hours}:${minutes}`; // Return in HH:mm format
}
async function openCustomModal(url: string): Promise<HTMLElement> {
    return new Promise<HTMLElement>((resolve, reject) => {
        fetch(url)
            .then((response) => {
                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }
                return response.text();
            })
            .then((data) => {
                const modalIdentifier = '#editModal' + luscinia.getModalLayerCount();
                const clWrapper = document.querySelector('#cl-wrapper');

                if (!clWrapper) {
                    throw new Error('cl-wrapper element not found in the document.');
                }

                clWrapper.insertAdjacentHTML('beforeend', data);

                const modalElement = document.querySelector(`${modalIdentifier}Form`);
                if (!modalElement) {
                    throw new Error(`Modal element ${modalIdentifier}Form not found.`);
                }

                luscinia.initModalDialog($(modalElement) as JQuery<HTMLFormElement>, modalIdentifier, luscinia.config, modalIdentifier);
                $(modalIdentifier).modal('show');
                resolve(document.querySelector(modalIdentifier) as HTMLElement);
            })
            .catch((error) => {
                console.error('Error fetching and displaying modal:', error);
                reject(error);
            });
    });
}
